import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import PinInput from 'react-pin-input';
import { toast } from 'react-toastify';
import iconSprite from '../../../assets/icon-sprite.svg';
import { acceptLoan } from '../../actions/p2p';

class AcceptLoan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: '',
      bear: 0,
    };
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleOnSubmit = async (e) => {
    e.preventDefault();
    const { onClose, onSubmit, data } = this.props;
    
    const { pin, bear } = this.state;
    this.setState({ loading: 'Processing' }, async () => {
      try {
        if (data.length <= 0) toast.error('No loan selected');
        if (data.length > 1) {
          const success = [];
          for (const {id} of data) {
            const response = await acceptLoan(id, pin, bear).catch(async (err) => err);
            if (response?.status == 'success') success.push(id);
          }
          toast.success(`${success?.length} of ${data.length} loans accepted`, {
            onClose: () => {
              window.location.reload(false);
            },
          });
        } else {
          const response = await acceptLoan(data[0].id, pin, bear);
          if (response.status !== 'success') throw new Error(response?.message);
          toast.success(response?.message);
          onClose?.();
          onSubmit?.();
        }
      } catch (error) {
        this.setState({ loading: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { visible, onClose = function $() { }, data = [] } = this.props;
    const { loading, pin, bear } = this.state;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <form
          className="modal-form"
          onSubmit={this.handleOnSubmit}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteCustomerLabel">Accept Loan?</h5>
              <button type="button" className="close" onClick={onClose}>
                <svg width="48" height="48">
                  <use xlinkHref={iconSprite + '#close-icon'}></use>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-body_message d-flex text-center justify-content-center align-items-center flex-column">
                {data.length === 1 && data[0]?.disbursement_fees && (
                  <div className="form-group d-flex justify-content-center flex-column">
                    <label htmlFor="amount" className="form-label">
                      How much of the
                      {' ₦'}
                      {Number(data[0].disbursement_fees).toLocaleString()}
                      {' '}
                      disbursement fee do you want to bear?
                    </label>
                    <label htmlFor="amount" className="form-label">
                      ₦
                      {Number(+data[0].loan_amount
                      - +data[0].disbursement_fees
                      + Math.min(+bear, data[0].disbursement_fees))
                        .toLocaleString()}
                      {' '}
                      would be disbursed to the borrower
                    </label>
                    <input
                      type="number"
                      className="form-control align-self-center"
                      id="bear"
                      name="bear"
                      onChange={this.handleOnChange}
                      placeholder="Enter amount to bear."
                      defaultValue={0}
                      min={0}
                      max={data[0].disbursement_fees}
                      style={{ width: '210px' }}
                      required />
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="pin" className="form-label">Enter your 4 Digit PIN to authorise this transaction:</label>
                  <PinInput
                    length={4}
                    focus
                    secret
                    type="numeric"
                    inputStyle={{ borderColor: '#00AEEF' }}
                    onChange={(value) => this.setState({ pin: value })} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                disabled={loading || pin.length !== 4}
                className="btn btn-primary">
                {loading || 'Accept Loan'}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default AcceptLoan;
